/**
 *Created by jmmartinez on 20/1/19
 * v.1.1  25/01/2019 Añadido ordenable.
 * v.1.2  22/03/2019 Añadido nivel.
 * v.1.3  10/04/2019 Cambio de llamda a CellRenderer para pasar el objeto columna completo.
 * v.1.4  23/04/2019 Añadidos métodos de Pie
 * v.1.5  07/05/2019 Modificado onSelection para el caso de pillar varias filas.
 * v.1.6  09/05/2019 Modificado onSelection para que ignore el row de Pie
 * v.1.7  04/06/2019 Añadida propiedad estilo para la envolvente.
 * v.1.8  24/10/2019 Añadido onKeyUp en la envolvente
 *                   Añadido buscador
 * v.1.9  25/10/2019 Añadida propiedad onAcceptedRow para cuando se le da a return.
 * v.1.10 28/10/2019 Modificado componentWillReceiveProps para que cada vez que se cambien los datos se ponga como activa la row 0.
 * v.1.11 29/10/2019 Añadida propiedad showBuscador
 *                   En componentDidUpdate comprobamos que existe this.refBuscador.current
 * v.1.115 29/10/2019 En OnFilterChange, informamos que el ElementoSeleccionado es el primero.
 *                    En OnFilterChange, después de filtrar llamamos al evento onSelectedRow con el primero.
 * v.1.12 30/10/2019 Añadida propiedad elementoSeleccionado, para reseleccionar un elemento al  volver al grid.
 *                   Modificado componentWillReceiveProps para obtener el row del elementoSeleccionado.
 *                   Añadidas propiedades valorBuscador y onValorBuscadorCambiado.
 *                   Añadida llamada a onVAlorBuscadorCambiado en el evento onValorBuscadorCambiado
 *                   Modificado componentWillReceiveProps para filtrar los datos si hay un valorBuscador definido
 * v.1.13 31/10/2019 Añadida variable interna focusBuscadorInicial para sólo forzar el focus del Buscador al principio y no en cada llmada a DidUpdate
 *                   Añadido onKeyUpBuscar para diferenciar del Tabla.
 *                   Añadido this.refTabla en el constructor para poder hacerle el focus().
 *                   Reestructurados los divs
 *                   Modificado el comportamiento de subir y bajar para no exceder los limites del numero de rows y de 0.
 * v.1.14 04/11/2019 En constructor, asignado selectedRow según el elementoSeleccionado que entra en las props.
 *
 * v.1.15 06/11/2019 En ComponentWillReceiveProps, añadimos la comprobación de la existencia de elementoSeleccionado
 * v.1.16 09/11/2019 Creado this.resourceImages.
 *                   Uso de resourceImages como parámetro de getCellRenderer en el componente <Table
 * v.1.17 11/11/2019 Añadidas propiedades editable.
 *                   Creados métodos cellValidator y cellSetter
 *                   Uso de getEditableCellRenderer.
 *                   Añadida propiedad onRowModificada;
 * v.1.18 12/11/2019 en OnSetter, tras guardar los datos y modificar DatosFiltrados devolvemos el focus.
 * v.1.19 02/03/2020 Añadido evento onNewRow para crear el elemento nuevo de la nueva fila.
 *                   En componente Table asignamos la propiedad enableFocusedCell={ editable ? true : false
 * v.1.20 03/03/2020 En CellSetter añadimos la validación y si no es válido borramos el valor.
 *                   En CellSetter añadimos la transformación de las cadenas a mayúsculas.
 *                   A onSelection sólo le asignamos la función si no es editable, para evitar comportamiento erroneo
 *                   En onKeyUpTabla, en flecha abajo, sólo creamos linea si es editable y el código del ultimo elemento no es cero,
 *                  con esta condicion comprobamos que no haya una línea pendiente de guardar.
 *                   Creamos la funcion rowGuardada que se pas como callback para ser llamada al realizar el guardado real de la línea.
 *                   En cellSetter llamamos onRowModificada con la funcion callback this.rowGuardada;
 *                   En render, el estilo del buscador es dinámico según sea editable o no.
 *                   En render, añadido un <div>Editable</div>.
 * v.1.22 16/03/2020 Eliminació de capacidades de modificación
 * v.1.22b 16/03/2020 En el render eliminamos el rowHeaderCellRenderer.
 *                    En el render descativamos el header con enableRowHeader={false}
 * v.1.23 13/04/2020  Añadido soporte para if y ConfiguracionGrid
 *                    Añadida importacion de grid.css
 * v.1.24 15/04/2020  Cambiado el parámetro usuarioCodigo a usuario em loadConfiguracion y como parametro a <ConfiguracionGrid>
 * v.1.25 01/05/2020  Añadidas capacidades de modificacion
 * v.1.26 06/05/2020  ? En la llamada a <Table>, asignamos selectedRegions con la funcion sólo si no es editable, para evitar bug.
 *                    En onKeyUpTabla, sumamos o restamos cantidad según sea editable o no.
 *                    Añadida la propiedad rowCambiada para usarla al presionar la flecha abajo.
 *                    Añadido mensaje de error en función nuevoRow cuando no está definido el prop. onNewRow
 * v.1.27 08/05/2020  Quitada la palabra editable porque añade un hueco entre el buscador y la tabla. Se sabe q es editable por la columna de estado.
 *                    Añadida gestion de Foreign:
 *                          - Añadido en el state: foreignOpened: false,
 *                          - Añadidas funciones: mostrarForeign, foreignAceptado, foreignCancelado
 * v.1.28 25/05/2020 Añadido alert de error en función nuevoRow cuando no está definido el prop. onNewRow
 * v.1.29 28/05/2020 solo se muestra <configuracionGrid si existe el usuario.
 * v.1.30 01/06/2020 Mostar dialogos de Fecha, FechaHora y Color con DialogoSelector
 * v.1.31 02/06/2020 Añadido en cellSetter los validadodes de porcentaje y color.
 * v.1.32 03/06/2020 Añadido en cellSetter el validador  y transformador de fecha
 * v.1.33 24/07/2020 Añadido evento onDatosModificados para cuando se modifican Datos por modificar un row.
 *                   Modificada funcion rowGuardada, para llamar a onDatosModificados
 * v.1.34 08/09/2020 Deshabilitada la opcion de redimensionar.
 * v.2.0   30/09/2020 Cambiado a framework2
 * v.2.1   06/08/2021DEsativada la carga de la configuracion
 **/

import React from 'react'
import {Table, Column, RowHeaderCell} from "@blueprintjs/table";
import "@blueprintjs/core/lib/css/blueprint.css";
import "@blueprintjs/table/lib/css/table.css";
import "@blueprintjs/icons/lib/css/blueprint-icons.css";
import {getCellRenderer } from "./CellRenderers";
import {
    CELLTIPO_CADENA,
    CELLTIPO_PORCENTAJE,
    CELLTIPO_FECHA,
   CELLTIPO_FECHAHORA, CELLTIPO_COLOR, CELLTIPO_COMBO
} from "../ej2/UI/TiposCeldas";
import {getColumnHeaderCellRenderer, getColumnHeaderCellRendererOrdenable, getColumnHeaderCellRendererFiltrable} from "./ColumnHeaderCellRenderers";
import PropTypes from 'prop-types';
import {ordenarConIndiceCampo} from "../ej2/utils/SortUtils";
import {calcularDatosConPie, mostrarPie} from "../ej2/utils/DatosUtils";
import { FormGroup, InputGroup, Dialog} from "@blueprintjs/core";
import {filtrarConTodosCampos, getPosElementoConNombreCampo} from "../ej2/utils/FilterUtils"
//import {loadConfiguracion} from "../ej2/utils/ConfiguracionInterfaceUtils"
import ConfiguracionGrid from "../ej2/UI/ConfiguracionGrid";
import "../resources/css/grid.css";
import {getEditableCellRenderer} from "./EditableCellRenderers";
import {getRaizForeign} from "../ej2/utils/ForeignUtils";
import {servicioRestfulMinimo, servidor} from "../../dental/Configuracion";
import DialogoSelectorLista from "../ej2/UI/DialogoSelectorLista";
import DialogoSelector from "../ej2/UI/DialogoSelector";
import {transformadorPorcentaje, transformadorCadenaFecha} from "../ej2/utils/Transformadores";
import {validadorColor, validadorPorcentaje, validadorCadenaFecha} from "../ej2/utils/Validadores";

class Grid extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            datos: null,
            datosFitrados: null,
            selectedRow: -1,
            valorBuscador: this.props.valorBuscador,
            mostrarConfiguracion: false,
            columnas: this.props.columnas,

            foreignOpened: false,
            foreignColumnaIndex: 0,
            selectorOpened: false,
            selectorColumnaIndex: 0,
        }

        if (props.elementoSeleccionado){
            this.state.selectedRow= props.datos && props.datos.length > 0 ?
                getPosElementoConNombreCampo(props.datos, "codigo", props.elementoSeleccionado.codigo)
                : -1;
        }
        else{
            this.state.selectedRow= props.datos && props.datos.length > 0 ? 0 : -1;
        }
        this.refBuscador= React.createRef();
        this.refTabla= React.createRef();
        this.focusBuscadorInicial= true;

        //Necesitamos esta variable para distinguir cuando ha habido un cambio real de row al darle a la flecha.
        //Mediante esta variable sabemos si ha habido una llamada real al evento onSelection
        //Nos hace falta para distinguir cuando estamos en la última fila y le damos abajo.
        this.rowCambiada= false;

        this.resourcesImages = require.context('../../dental/resources/images/', true);
    }

    componentDidMount() {
        /*
        const {usuario, ifid} = this.props;

        if (ifid && usuario) {
            loadConfiguracion(ifid, usuario, this.props.columnas, (nuevasColumna) => {
                this.setState({columnas: nuevasColumna});
            });
        }

         */
    }


    componentDidUpdate() {
        //Tenemos que hacer la llamada aquí porque es el punto en el que se han cargado los refs correctamente
        if (this.focusBuscadorInicial === true &&this.refBuscador && this.refBuscador.current) {
            this.focusBuscadorInicial= false;
            this.refBuscador.current.focus();
        }
    }

    //Para sustituir a WillṔrops
    static getDerivedStateFromProps(nextProps, prevState) {
        const newState = {};

        if (nextProps.datos !== prevState.datos) {
            //console.log("Dentro!");
            newState.datos = nextProps.datos;
            newState.datosFiltrados = nextProps.datos;

            //Filtramos los datos si viene valorBuscadorInicial:
            if (nextProps.datos.length > 0 && nextProps.valorBuscador){
                newState.datosFiltrados = filtrarConTodosCampos(nextProps.datos, nextProps.valorBuscador);
            }

            let newSelectedRow= -1;
            if (nextProps.datos && nextProps.datos.length > 0){
                if (nextProps.elementoSeleccionado)
                    newSelectedRow= getPosElementoConNombreCampo(newState.datosFiltrados, "codigo", nextProps.elementoSeleccionado.codigo);
                else
                    newSelectedRow= 0;
                newState.selectedRow= newSelectedRow;
            }

            if (mostrarPie(nextProps.columnas)) {
                newState.datos = calcularDatosConPie(nextProps.columnas, nextProps.datos);
                newState.datosFiltrados= newState.datos;
            }
        }


        //#Nuevo
        if (nextProps.elementoSeleccionado !== prevState.elementoSeleccionado) {
            //console.log("WILL elementoSeleccionado:");
            //console.log(elementoSeleccionado);
            newState.elementoSeleccionado = nextProps.elementoSeleccionado;
            let newSelectedRow= nextProps.elementoSeleccionado && nextProps.datos && nextProps.datos.length > 0 ?
                getPosElementoConNombreCampo(nextProps.datos, "codigo", nextProps.elementoSeleccionado.codigo)
                : -1;
            newState.selectedRow= newSelectedRow;
        }


        if (Object.keys(newState).length > 0)
            return newState;
        else
            return null;
    }



    //Para cuando al seleccionar mueves el raton y pillas varios rows.
    onSelection= (e) => {
        const {datosFiltrados} = this.state;
        const {onSelectedRow} = this.props;
        if (e.length > 0 && e[0].rows) {
            let row= e[0].rows[e[0].rows.length-1];
            if (datosFiltrados[row].esPie)
                return;
            let elemento= datosFiltrados[row];
            this.setState({selectedRow:  row}, () => {
                //console.log("rowCambiada");
                this.rowCambiada= true;
            });
            onSelectedRow && onSelectedRow(row, elemento); //#
        }
    }

    getSelectedRegion() {
        var region = [];
        if (this.state.selectedRow >= 0)
            region = [{rows: [this.state.selectedRow, this.state.selectedRow]}];
        return region;

    }

    selectRow= (row) => {
        const {datos, datosFiltrados, selectedRow} = this.state;
        const {onSelectedRow} = this.props;
        let elemento= null;
        if (row >= 0 && row < datosFiltrados.length && datosFiltrados.length > 0) {
            elemento = datosFiltrados[row];
        }
        this.setState({selectedRow: row});
        onSelectedRow && onSelectedRow(row, elemento); //#
    }


    getColumnasAnchos(columnas) {
        let anchos = columnas.reduce((anchosReduced, columna) => {
            anchosReduced.push(columna.ancho);
            return anchosReduced;
        }, []);
        return anchos;
    }


    getNumRows(columnas, datos){
        let numRows= datos ? datos.length : 0;
        return numRows;
    }

    onKeyUpBuscar= (event) => {
        switch (event.keyCode) {
            case 13: this.refTabla.current.focus(); break;
        }
    }

    onKeyUpTabla= (event) => {
        const {selectedRow, datosFiltrados} = this.state;
        const {onAcceptedRow, editable} = this.props;

        //Cuando es editable no hay que sumar ni restar pq ya lo hace el componente.
        //Cuando no es editable sí sumamos y restamos uno según la flecha
        let variacion= editable ? 0 : 1;
        switch (event.keyCode){

            case 40://Flecha hacia abajo
                if (selectedRow < datosFiltrados.length - 1)
                    this.selectRow(selectedRow + variacion);
                else{
                    if (editable &&  Boolean(editable) && !this.rowCambiada ) {
                        //Si la ultima fila no es nueva, se puede crear
                        if (datosFiltrados[selectedRow].codigo > 0)
                            this.nuevoRow();
                    }
                }
                break;
            case 13:
                console.log("return");
                onAcceptedRow && onAcceptedRow(datosFiltrados[selectedRow]);
                break;

            case 44://SUPR
                //if (editable && Boolean(editable))
                //this.deleteRow();
                break;
        }
        this.rowCambiada= false;

    }


    onKeyUpCell= (event, columnIndex, row) => {
        const {selectedRow, datosFiltrados, columnas} = this.state;
        const {onAcceptedRow, editable} = this.props;
        switch (event.keyCode) {
            case 17: //CRTL

                if (editable && Boolean(editable)) {
                    let colSeleccionada = columnIndex;
                    let columna= columnas[colSeleccionada];
                    if (columna) {
                        let columnaNoEditable = typeof columna.editable !== 'undefined' && !Boolean(columna.editable);
                        switch (columna.tipo) {
                            case CELLTIPO_FECHA:
                            case CELLTIPO_FECHAHORA:
                            case CELLTIPO_COLOR:
                            case CELLTIPO_COMBO:
                                if (!columnaNoEditable)
                                    this.mostrarSelector(colSeleccionada);
                                break;
                            default:
                                if (!columnaNoEditable && columna.clase) {
                                    this.mostrarForeign(colSeleccionada);
                                }
                                break
                        }
                    }
                }
                break;
        }

    }


    onSortEvent= (columnIndex, direccion) => {
        const {datosFiltrados} = this.state;
        const {columnas} = this.props;
        let newDatos= ordenarConIndiceCampo(columnas, datosFiltrados, columnIndex, direccion);
        this.setState({datosFiltrados: newDatos});
    }

    onFilterChange= (newValorBuscador) => {
        const {datos} = this.state;
        const {onValorBuscadorCambiado} = this.props;
        //let newDatosFiltrados= filtrarConNombreCampo(datos, "nombre", newValorBuscador);
        let newDatosFiltrados= filtrarConTodosCampos(datos, newValorBuscador);
        this.setState({valorBuscador: newValorBuscador, datosFiltrados: newDatosFiltrados}, () => {
                                            this.selectRow(0);
                                        });
        onValorBuscadorCambiado && onValorBuscadorCambiado(newValorBuscador);

    }

    //------------------------------------------------------------------------------------------------------------------
    // EDICION
    //------------------------------------------------------------------------------------------------------------------


    renderRowHeaderCell = (rowIndex) => {
        const {datosFiltrados} = this.state;
        if (datosFiltrados[rowIndex].modificado)
            return <RowHeaderCell style={{backgroundColor: "red"}} name={"*"} />;
        else {
            let rowIndexString = (rowIndex + 1).toString();
            if (datosFiltrados[rowIndex].guardado)
                return <RowHeaderCell style={{backgroundColor: "green", color: "white"}} name={rowIndexString} />;
            else
                return <RowHeaderCell name={rowIndexString}/>;
        }

    };

    cellValidator = (rowIndex, columnIndex) => {
        const{columnas} = this.props;
        return (value) => {
            console.log("Validator -> " + rowIndex.toString() + " " + columnIndex.toString());
        };
    };

    cellSetter = (rowIndex, columnIndex) => {
        return (value) => {
            console.log("Setter -> " + rowIndex.toString() + " " + columnIndex.toString());
            const {datosFiltrados} = this.state;
            const {columnas, onRowModificada, elementoConfig} = this.props;
            let columna= columnas[columnIndex];
            let campo= columna.campo;
            let valorOriginal= datosFiltrados[rowIndex][campo];

            //Es un dato valido?
            let valido= true;
            if (columna.validador)
                valido= columna.validador(value);
            else{
                switch (columna.tipo){
                    case CELLTIPO_COLOR: valido= validadorColor(value); break;
                    case CELLTIPO_PORCENTAJE: valido= validadorPorcentaje(value); break;
                    case CELLTIPO_FECHA: valido= validadorCadenaFecha(value); break;
                }
            }

            if (!valido){
                let newDatosFiltrados= [...this.state.datosFiltrados];
                let valorDefecto= "";
                switch (columna.tipo){
                    case CELLTIPO_COLOR: valorDefecto= "#fff"; break;
                    case CELLTIPO_PORCENTAJE: valorDefecto= "0"; break;
                    case CELLTIPO_FECHA: valorDefecto= new Date(); break;
                }
                newDatosFiltrados[rowIndex][campo]= valorDefecto;
                this.setState({datosFiltrados: newDatosFiltrados})
                return;
            }

            //¿Hay transformaciones
            let valueTransformado= value;
            switch (columna.tipo){
                case CELLTIPO_CADENA:
                    valueTransformado= value.toUpperCase();
                    break;
                case CELLTIPO_PORCENTAJE:
                    valueTransformado= transformadorPorcentaje(value);
                    break;
                case CELLTIPO_FECHA:
                    valueTransformado= transformadorCadenaFecha(value);
                    break;
            }

            //¿Hay modificacion?
            if (valueTransformado !== valorOriginal){
                const oldObject= {...datosFiltrados[rowIndex]};
                let newDatosFiltrados= datosFiltrados.slice();
                newDatosFiltrados[rowIndex][campo]= valueTransformado;
                newDatosFiltrados[rowIndex].modificado= true;
                let newObject= newDatosFiltrados[rowIndex];

                this.setState({datosFiltrados: newDatosFiltrados}, () => {
                    if (onRowModificada) {
                        let guardado = onRowModificada(oldObject, newObject, rowIndex, this.rowGuardada);
                        if (guardado){
                            delete newDatosFiltrados[rowIndex].modificado;
                            newDatosFiltrados[rowIndex].guardado= true;
                        }
                    }
                });
                //this.refTabla.current.focus();
            }

        };
    };

    rowGuardada = (objetoGuardado, rowIndex) => {
        //console.log("rowGuardada");
        const {datos, datosFiltrados} = this.state;
        const {onDatosModificados} = this.props;

        let newDatos= datos.slice();
        if (newDatos.length <= rowIndex)
            newDatos.push(objetoGuardado);
        else
            newDatos[rowIndex]= objetoGuardado;

        let newDatosFiltrados= datosFiltrados.slice();
        newDatosFiltrados[rowIndex]= objetoGuardado;
        newDatosFiltrados[rowIndex].guardado= true;

        this.setState({datos: newDatos, datosFiltrados: newDatosFiltrados}, () => {
            onDatosModificados && onDatosModificados(newDatos);
        });
    }

    nuevoRow = () =>{
        const {onNewRow} = this.props;
        if (onNewRow){
            let newElemento= onNewRow();
            let newDatos= [...this.state.datosFiltrados];
            newDatos.push(newElemento);
            this.setState({datosFiltrados: newDatos}, () =>{
                this.selectRow(newDatos.length-1); //No tengo muy claro pero esto hace falta para poner el foco en la siguiente columna.
            });
        }
        else {
            console.log("ERROR: No está definido el prop. onNewRow");
            alert("ERROR: No está definido el prop. onNewRow");
        }
    }


    //------------------------------------------------------------------------------------------
    // MOSTRAR FOREIGN
    //------------------------------------------------------------------------------------------
    mostrarForeign = (colSeleccionada) => {
        const {columnas} = this.props;
        let columna= columnas[colSeleccionada];
        this.setState({foreignOpened: true, foreignColumna: columna});
    }

    foreignAceptado = (valorForeign) => {
        const {datos, foreignColumna, selectedRow} = this.state;
        const { onRowModificada} = this.props;

        //sustituimos el elemento:
        let oldObjeto= datos[selectedRow];
        let campoForeign= foreignColumna.campo;
        let propiedadForeign= getRaizForeign(campoForeign);
        let newObjeto = {...oldObjeto};
        newObjeto[propiedadForeign]= valorForeign;
        newObjeto.estadoRow= "PENDIENTE";
        let newDatos = datos.slice();
        newDatos[selectedRow] = newObjeto;

        this.setState({foreignOpened: false, datos: newDatos, datosFiltrados: newDatos}, () =>{
            if (onRowModificada) {
                onRowModificada(oldObjeto, newObjeto, selectedRow, this.rowGuardada);
            }
        });

    }

    foreignCancelado = () => {
        this.setState({foreignOpened: false});
    }

    //------------------------------------------------------------------------------------------


    //------------------------------------------------------------------------------------------
    // MOSTRAR SELECTOR
    //------------------------------------------------------------------------------------------
    mostrarSelector = (colSeleccionada) => {
        const {columnas} = this.props;
        console.log("mostrarSelector");
        let columna= columnas[colSeleccionada];
        this.setState({selectorOpened: true, selectorColumna: columna});
    }

    selectorAceptado = (valor) => {
        const {datos, selectorColumna, selectedRow} = this.state;
        const { onRowModificada} = this.props;

        //sustituimos el elemento:
        let oldObjeto= datos[selectedRow];
        let campoFecha= selectorColumna.campo;
        let newObjeto = {...oldObjeto};
        newObjeto[campoFecha]= valor;
        newObjeto.estadoRow= "PENDIENTE";
        let newDatos = datos.slice();
        newDatos[selectedRow] = newObjeto;

        this.setState({selectorOpened: false, datos: newDatos, datosFiltrados: newDatos}, () =>{
            if (onRowModificada) {
                onRowModificada(oldObjeto, newObjeto, selectedRow, this.rowGuardada);
            }
        });

    }

    selectorCancelado = () => {
        this.setState({selectorOpened: false});
    }

    //------------------------------------------------------------------------------------------------------------------
    // CONFIGURACION
    //------------------------------------------------------------------------------------------------------------------

    configurar = () => {
        //Mostramos el dialogo
        this.setState({mostrarConfiguracion: true});
    }

    onAceptarConfiguracion = (newColumnas) => {
        const {columnas} = this.props;
        this.setState({mostrarConfiguracion: false, columnas: newColumnas});
        this.onCloseConfiguracion();
    }

    onCloseConfiguracion = () => {
        this.setState({mostrarConfiguracion: false});
    }


    //------------------------------------------------------------------------------------------------------------------
    // RENDER
    //------------------------------------------------------------------------------------------------------------------


    render() {
        const {datosFiltrados, valorBuscador, selectedRow,
                columnas, mostrarConfiguracion,
                foreignOpened, foreignColumna,
                selectorOpened, selectorColumna} =  this.state;
        const {nivel, ordenable, estilo, showBuscador,
               ifid, usuario,
               editable, cellValidator, cellSetter} = this.props;
        let showRowHeader= typeof editable === 'boolean' && editable === true;
        let columnWidths= this.getColumnasAnchos(columnas);
        let buscarStyle=  {marginBottom: '10px'};

        let foreignClase= foreignColumna ? foreignColumna.clase : null;

        //console.log("GRID - RENDER");
        //console.log(datosFiltrados);

        return (
            <div style= {estilo}>

                {usuario &&
                <Dialog icon="git-push"
                        title={"Configuración"}
                        onClose={this.onCloseConfiguracion}
                        isOpen={mostrarConfiguracion}
                        usePortal={true}
                        style={{width: "60%"}}
                >
                    <ConfiguracionGrid
                        ifid={ifid} usuario={usuario}
                        columnas={this.props.columnas} columnasActuales={columnas}
                        onAceptar={this.onAceptarConfiguracion} onCancelar={this.onCloseConfiguracion}/>
                </Dialog>
                }


                {(showBuscador == undefined || showBuscador === true) &&
                <div className="grid-contenedorsuperior">
                    <FormGroup label="Buscar" style={buscarStyle}  labelFor="igBuscador" inline={true}>
                        <InputGroup
                            id="igBuscador"
                            leftIcon="search"
                            placeholder="Buscar"
                            value={valorBuscador ? valorBuscador : ""}
                            onChange={(event) => this.onFilterChange(event.target.value)}
                            onKeyUp={this.onKeyUpBuscar}
                            inputRef={this.refBuscador}
                        />
                    </FormGroup>
                </div>
                }


                <div style= {estilo} onKeyUp={this.onKeyUpTabla} tabIndex="-1" ref={this.refTabla}>
                    <Table numRows={ this.getNumRows(columnas, datosFiltrados)}
                                 columnWidths={columnWidths}
                                 onSelection={(e) => this.onSelection(e)}
                                 selectedRegions={this.getSelectedRegion()}
                                 className="tabla"
                                 enableColumnResizing={false}
                                 enableRowHeader={showRowHeader}
                                 enableFocusedCell={ editable ? true : false}
                                 rowHeaderCellRenderer={this.renderRowHeaderCell}
                          >
                        {columnas.map((columna, i) => {
                            return <Column key={i}
                                           name={columna.titulo}
                                           columnHeaderCellRenderer={ ordenable ?
                                               getColumnHeaderCellRendererOrdenable(columna.titulo, i, this.onSortEvent) :
                                               getColumnHeaderCellRenderer(columna.titulo) }
                                           cellRenderer={
                                               editable ?
                                                   getEditableCellRenderer(this.cellValidator, this.cellSetter, i, columna, nivel, datosFiltrados, this.resourcesImages, this.onKeyUpCell) :
                                                   getCellRenderer(columna, nivel, datosFiltrados, this.resourcesImages)
                                           } />
                        })}

                    </Table>
                </div>

                <DialogoSelectorLista //datos={datosForeign}
                    opened={foreignOpened}
                    gridColumnaCampo={"nombre"}
                    gridColumnaTitulo={"nombre"}
                    onAceptado={this.foreignAceptado}
                    onCancelado={this.foreignCancelado}
                    clase={foreignClase}
                    urlServicioRestful={servidor + servicioRestfulMinimo}  />


                <DialogoSelector
                    opened={selectorOpened}
                    onAceptado={this.selectorAceptado}
                    onCancelado={this.selectorCancelado}
                    selectedRow={selectedRow >= 0  && datosFiltrados ? datosFiltrados[selectedRow] : null}
                    columna={selectorColumna}
                />

            </div>
        );
    }
}

/*
{   ifid &&
                        <div style={{width: 50, padding: 5}}>
                            <Button icon="git-push" small={true} minimal={true} onClick={this.configurar}/>
                        </div>
                    }
 */

Grid.propTypes = {
    columnas: PropTypes.array.isRequired,
    nivel: PropTypes.object,
    datos: PropTypes.array,
    onSelectedRow: PropTypes.func,
    onDeleteRow: PropTypes.func,
    ordenable: PropTypes.bool,
    estilo: PropTypes.object,
    onAcceptedRow: PropTypes.func,
    //mostrarEncabezado: PropTypes.bool,
    showBuscador: PropTypes.bool,
    elementoSeleccionado: PropTypes.object,
    valorBuscador: PropTypes.string,
    onValorBuscadorCambiado: PropTypes.func,

    ifid: PropTypes.string,
    usuario: PropTypes.object,

    editable: PropTypes.bool,
    onRowModificada: PropTypes.func,
    onNewRow: PropTypes.func,
    onDatosModificados: PropTypes.func,
}

export default Grid

